import { isArray } from '@ember/array';

/**
 * @deprecated
 * deprecated method, do not use, included for backwards compatibility
 * https://deprecations.emberjs.com/id/deprecate-import-make-array-from-ember/
 */
export function makeArray<T, TT>(obj: T): T extends TT[] ? T : T extends null | undefined ? [] : [T];
export function makeArray(
  obj: Record<string, unknown> | null | undefined,
): Array<Record<string, unknown> | null | undefined> {
  if (obj === null || obj === undefined) {
    return [];
  }
  return isArray(obj) ? <Array<Record<string, unknown>>>(<unknown>obj) : [obj];
}
